module.exports = __webpack_public_path__ + "media/images/icons/question_key-a1f1958d58acbac38be3d433c47f0ba7.svg";